




























































import { SwModal, SwModalBody, SwModalFooter } from '@libs-uuif/shared/sw-modal';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { Component, Prop } from 'vue-property-decorator';
import { SwButton } from '@libs-uuif/shared/sw-button';
import { envCongif } from '@/shared/env.config';
const cssPrefix = 'account-locked';

@Component({
  components: {
    SwModal,
    SwModalBody,
    SwModalFooter,
    SwButton,
  },
})

export default class SwAccountLockedDialog extends SwExtendedVue {

  @Prop({ required: true })
  showAccLockModal: boolean;

  @Prop({ required: true })
  email: any;

  @Prop({ required: true })
  ifUserTypeEmployee: boolean;

  cssPrefix = cssPrefix;

  get getHeader() {
    return this.$t('login.tooManyLogins')
    .toString();
  }

  onClickResetPassword() {
    const url: string = `${envCongif.accounts_url}/forgotpassword?email=${this.email}`;
    window.open(url);
  }

  onClickCustomerSupport() {
    const url: string = 'https://www.sonicwall.com/en-us/support/contact-support';
    window.open(url, '_blank');
  }

  onCloseDialog() {
    this.$emit('closeAccountBlockedDialg');
  }
}
